import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { ApplicationMessagesAction } from '../state-management/application-messages/application-message.action';

@Injectable({ providedIn: 'root' })
export class NetworkService {

    constructor(private store: Store<any>) {}

    /**
     * Realiza download de um blob
     *
     * @param  {any} file
     * @param  {string} name
     */
    public async downloadFile(file: any, name: string) {

        // Verifica se o arquivo a ser baixado é um PDF válido, se não for cancela o download e exibe um erro genérico
        if (! await this.isValidPDF(file)) {
            return this.store.dispatch({
                type: ApplicationMessagesAction.genericError,
                payload: { message: 'Não foi possível fazer o download: Arquivo inválido.' },
            });
        }

        // Cria um blob do buffer PDF
        const blob = new Blob([file], { type: 'application/pdf' });

        if (window.navigator && (window.navigator as any).msSaveOrOpenBlob) {
            return (window.navigator as any).msSaveOrOpenBlob(blob);
        }

        // Disponibiliza a URL do blob
        const data = window.URL.createObjectURL(blob);

        // Cria link para download do blob
        const linkElement = document.createElement('a');
        linkElement.href = data;
        linkElement.download = name;
        linkElement.click();

        // Após download revoga a URL do blob e destroi o link
        setTimeout(() => window.URL.revokeObjectURL(data), 100);
    }

    /**
     * Verifica se um blob é de uma PDF válido
     *
     * @param  {Blob} file
     */
    private async isValidPDF(file: Blob) {
        return (await new Response(file).text())
            .slice(0, 6)
            .includes('%PDF-');
    }
}
